export const useSocialLinks = () => {
  const config = useRuntimeConfig();

  return [
    {
      href: `mailto:${config.public.contactEmail}`,
      icon: "mdi-email-outline", // outlined email
      title: "Email",
    },
    {
      href: config.public.faceBookUrl,
      icon: "mdi-facebook", // no outlined version
      title: "Facebook",
    },
    {
      href: config.public.instagramUrl,
      icon: "mdi-instagram", // no outlined version
      title: "Instagram",
    },
    {
      href: config.public.telegramLink,
      icon: "ic:baseline-telegram", // outlined phone
      title: "Telegram",
    },
    {
      href: `https://wa.me/${String(config.public.whatsappNumber || "").replace(/\D/g, "")}`,
      icon: "mdi-whatsapp",
      title: "WhatsApp",
    },
    {
      href: `tel:${config.public.whatsappNumber}`,
      icon: "ic:baseline-phone", // outlined phone
      title: "Phone",
    },
  ];
};

